'use client'
import { persist, createStore } from '@dynamic-labs/store';
import { STORE_STORAGE_KEY } from '../../utils/constants/localStorage.js';
import '../../utils/constants/colors.js';
import '../../utils/constants/values.js';
import { transformStateForLocalStorage, createInitialStates, storeVersion } from '../stateConfig.js';
import { syncLegacyStorage } from './utils/syncLegacyStorage/syncLegacyStorage.js';

let store;
const getStore = () => {
    if (!store) {
        throw new Error('Store not initialized');
    }
    return store;
};
const removeStoreInstance = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    store = undefined;
};
const initializeStore = (props) => {
    var _a;
    if (store) {
        return;
    }
    const { localStorageSuffix } = (_a = props.settings) !== null && _a !== void 0 ? _a : {};
    const persistName = localStorageSuffix
        ? `${STORE_STORAGE_KEY}_${localStorageSuffix}`
        : STORE_STORAGE_KEY;
    store = syncLegacyStorage(persist({
        name: persistName,
        partialize: transformStateForLocalStorage,
        storage: getStorage(),
        // Map each entry to its initialValue
        store: createStore(() => createInitialStates(props)),
        version: storeVersion,
    }));
};
const getStorage = () => {
    if (typeof localStorage === 'undefined') {
        return {
            getItem: () => null,
            setItem: () => { },
        };
    }
    return window.localStorage;
};

export { getStore, initializeStore, removeStoreInstance };
